import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  ContractHistoryContractVersionHistoryFragment,
  ContractHistoryContractVersionUpdateFragment,
} from 'generated/resources/graphql'

import CreatedBy from 'modules/contracts/components/NewContractHistory/ContractVersionCard/CreatedBy'
import { mapUpdate } from 'modules/contracts/lib/ContractHistoryUtils'

interface Props {
  contractVersion: ContractHistoryContractVersionHistoryFragment
  contractVersionUpdates: ContractHistoryContractVersionUpdateFragment[]
}

const CardContent = ({ contractVersion, contractVersionUpdates }: Props) => {
  const legalEntityId = contractVersion.employee?.legalEntity?.id

  if (contractVersionUpdates.length === 0) {
    return null
  }

  const formattedChanges = contractVersionUpdates
    .map((update) => mapUpdate(update, contractVersionUpdates, legalEntityId || 0))
    .filter((u): u is NonNullable<typeof u> => Boolean(u))

  return (
    <Box flexDirection="column" gap="s12" paddingBottom="s8">
      <Box flexDirection="column" gap="s12" paddingTop="s8">
        {formattedChanges.map((field, i) => (
          <Box key={i} flexDirection="row" gap="s12" alignItems="flexStart">
            <Box flexDirection="row" gap="s4" alignItems="center" width="s200">
              <Text.Normal size="200" weight="normal" color="grey800">
                {field.field}
              </Text.Normal>
            </Box>
            <Box flexDirection="column" gap="s4" alignItems="flexStart" maxWidth="s200">
              <Text.Normal size="200" color="grey1000" weight="medium">
                {field.newValue || 'None'}
              </Text.Normal>
              {field.oldValue && (
                <Text.Normal size="200" color="grey800" weight="normal" stroked>
                  {field.oldValue}
                </Text.Normal>
              )}
            </Box>
          </Box>
        ))}
      </Box>
      <CreatedBy version={contractVersion} />
    </Box>
  )
}

export default CardContent
